/*
 * INDRAAZ — sticky "See offers" bar for products with the bundle tier
 * picker active. Simpler than idz-sticky-atc-fallback.js: no Rapi
 * detection, no quantity stepper, no cart submission — this bar's only
 * job is showing after the buy box scrolls out of view and jumping the
 * visitor back to the bundle picker on click.
 */
(function () {
  if (window.__idzStickyBundleCtaBound) return;
  window.__idzStickyBundleCtaBound = true;

  var NEAR_TOP_PX = 40;

  function bindScroll(bar) {
    var mainForm = document.querySelector('[data-idz-atc-main-sync]') || document.querySelector('[data-idz-bundle]') || document.querySelector('[data-idz-bogo]');
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var rect = mainForm ? mainForm.getBoundingClientRect() : null;
        var pastBuyBox = rect ? rect.bottom < 0 : true;
        var atTop = window.scrollY <= NEAR_TOP_PX;
        bar.classList.toggle('idz-sticky-fallback--visible', pastBuyBox && !atTop);
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function bindClick(bar) {
    var button = bar.querySelector('[data-idz-sticky-bundle-cta-button]');
    var bundleEl = document.querySelector(bar.dataset.target);
    if (!button || !bundleEl) return;

    // Scrolls up to the product TITLE, not the bundle picker itself — a
    // plain scrollIntoView on the bundle only revealed the tiers, cutting
    // off the main price block right above them. Landing on the title
    // instead keeps the title, price, and bundle tiers all in view at
    // once, same idea as "see the offer in its full context", not just
    // the tiers alone.
    var titleEl = document.querySelector('.product__title');

    button.addEventListener('click', function () {
      if (!titleEl) {
        bundleEl.scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
      }

      var header = document.querySelector('.section-header');
      var headerHeight = header ? header.getBoundingClientRect().height : 0;
      var EXTRA_GAP_PX = 16;
      var targetTop = titleEl.getBoundingClientRect().top + window.scrollY - headerHeight - EXTRA_GAP_PX;
      window.scrollTo({ top: Math.max(0, targetTop), behavior: 'smooth' });
    });
  }

  function start() {
    document.querySelectorAll('[data-idz-sticky-bundle-cta]').forEach(function (bar) {
      bar.hidden = false;
      bindScroll(bar);
      bindClick(bar);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
